import { animate, AnimationTriggerMetadata, state, style, transition, trigger } from '@angular/animations';

// Component transition animations
export const slideInDownAnimation: AnimationTriggerMetadata = trigger('routeAnimation', [
	state(
		'void',
		style({
			// position: 'fixed',
			width: '100%'
		})
	),
	state(
		'*',
		style({
			// position: 'fixed',
			width: '100%'
		})
	),
	transition(':enter', [
		style({
			// transform: 'translateX(100%)'
			opacity: '0'
		}),
		animate(
			'0.3s ease-in',
			style({
				// transform: 'translateX(0%)'
				opacity: '1'
			})
		)
	]),
	transition(':leave', [
		style({
			opacity: 'o'
		})
		// animate('0.1s ease-out', style({
		// 	opacity: '0'
		// }))
	])
]);
